const headerEl = document.querySelector( '.js-page-header' );
const headerContainer = headerEl.querySelector( '.js-page-header-container' );
const headerNavEl = headerEl.querySelector( '.js-menu-header' );
const mobileNavEl = headerEl.querySelector( '.js-menu-mobile' );
const mobileBreakpoint = window.matchMedia( "(max-width: 1024px)" );
const bodyEl = document.querySelector( 'body' );

/**
 * Check if the menu exists
 *
 * @return {boolean}
 */
const checkMenu = () => {

	if ( !headerEl ) {

		return false;

	}

	if ( !headerNavEl ) {

		return false;

	}
	if ( !mobileNavEl ) {

		return false;

	}
	return true;

}


/**
 * Mega menu positions
 */
const megaMenuPositions = () => {

	if ( !checkMenu() ) {

		return;

	}

	const subMenus = headerEl.querySelectorAll( '.page-header-nav .js-header-submenu' );
	subMenus.forEach( ( subMenu ) => {

		subMenu.initWidth = subMenu.offsetWidth;

	} );

	/**
	 * Calculate the position of the submenu
	 */
	const calcSubmenuPosition = () => {

		if ( mobileBreakpoint.matches ) {

			return;

		}
		const containerRect = headerContainer.getBoundingClientRect();

		subMenus.forEach( ( subMenu ) => {

			const initWidth = subMenu.initWidth === 0 ? subMenu.offsetWidth : subMenu.initWidth;
			subMenu.style.width = `${initWidth}px`;
			subMenu.style.left = '';
			let subMenuRect = subMenu.getBoundingClientRect();

			if ( subMenuRect.width > containerRect.width ) {

				subMenu.style.width = `${containerRect.width}px`;
				subMenuRect = subMenu.getBoundingClientRect();

			}
			if ( subMenuRect.left < containerRect.left ) {

				const submenuOffset = subMenuRect.left - containerRect.left;
				subMenu.style.left = `${subMenu.offsetLeft-submenuOffset}px`;

			} else if ( subMenuRect.right > containerRect.right ) {

				const submenuOffset = subMenuRect.right - containerRect.right;
				subMenu.style.left = `${subMenu.offsetLeft-submenuOffset}px`;

			}

		} );


	}
	window.addEventListener( 'resize', () => calcSubmenuPosition() );
	calcSubmenuPosition();

}


/**
 * Prepare the mobile menu
 *
 * @return {void}
 */
const prepareMobileMenu = () => {

	/* Prepare the mobile menu, replace main menu walker classes */
	mobileNavEl.querySelectorAll( '*' ).forEach( ( menuItem ) => {

		if ( menuItem.className !== '' ) {

			menuItem.className = menuItem.className.replace( /\bc-menu-header\b/g, 'c-menu-mobile' );

		}

	} );

}

/**
 * Mobile Button
 *
 * @return {void}
 */
const mobileTrigger = () => {

	const hamburgerButton = headerEl.querySelector( '.js-mobile-menu-button' );

	hamburgerButton.addEventListener( 'click', ( e ) => {

		if ( mobileBreakpoint.matches ) {

			headerEl.classList.toggle( 'page-header--mobile-open' );
			bodyEl.classList.toggle( 'freeze' );

		}
		e.preventDefault();

	} );

}

/**
 * Mobile Accordion
 *
 * @return {void}
 */
const mobileAccordion = () => {

	const footerTriggers = mobileNavEl.querySelectorAll( '.js-menu-header-has-children .js-menu-header-trigger' );
	footerTriggers.forEach( ( trigger ) => {

		trigger.addEventListener( 'click', ( e ) => {

			e.preventDefault();
			if ( mobileBreakpoint.matches ) {

				trigger.classList.toggle( 'is-active' );
				const panel = trigger.nextElementSibling;
				if ( panel.style.maxHeight ) {

					panel.style.maxHeight = null;

				} else {

					panel.style.maxHeight = `${ panel.scrollHeight }px`;

				}
				trigger.nextElementSibling.classList.toggle( 'is-active' );

			}

		} );

	} );

}

/**
 * Search header
 * @return {void}
 */
const searchheader = () => {

	const searchButton = headerEl.querySelector( '.js-search-open-popup' );
	if ( !searchButton ) {

		return;

	}
	const searchPopup = headerEl.querySelector( '.js-search-popup' );
	const searchClose = headerEl.querySelectorAll( '.js-search-close-popup' );
	searchButton.addEventListener( 'click', ( e ) => {

		searchPopup.classList.toggle( 'is-active' );
		e.preventDefault();

	} );
	searchClose.forEach( ( close ) => {

		close.addEventListener( 'click', ( e ) => {

			searchPopup.classList.remove( 'is-active' );
			e.preventDefault();

		} );

	} );

}

/**
 * Mobile menu
 *
 * @return {void}
 */
const mobileMenu = () => {

	if ( !checkMenu() ) {

		return;

	}

	prepareMobileMenu();
	mobileTrigger();
	mobileAccordion();
	searchheader();

}

export { mobileMenu, megaMenuPositions };